import React from "react";
import { useNavigate } from "react-router-dom";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import LeftBarSports from "../../../components/LeftBarSports";
import BaccaratClassic from "../../../../assets/images/banner/BaccaratClassic.jpg";
import SicBo from "../../../../assets/images/banner/SicBo.jpg";
import RedBlueDuel from "../../../../assets/images/banner/RedBlueDuel.jpg";
import awcthaifishprawncrab from "../../../../assets/images/banner/awcthaifishprawncrab.jpg";
import ExtraAndarBahar from "../../../../assets/images/banner/ExtraAndarBahar.jpg";

import Footer from "../../../../containers/Footer";
import BackIcon from "../../../../assets/svg/BackIcon";

const AeSexy = () => {
  const navigate = useNavigate();

  return (
    <>
      <HeaderAfterLogin />

      <main className="main" style={{ height: "100vh" }}>
        <div className="d-xl-none mt--14">
          <LeftBarSports />
        </div>

        <div className="container">
          <div className="heading my-4">
            <h4>AeSexy</h4>
            <div className="back-link" onClick={() => navigate(-1)}>
              Back <BackIcon />
            </div>
          </div>

          <div className="providerSection">
            <ul style={{ justifyContent: "flex-start" }}>
              <li>
                <a href="/casino/awc-baccarat-classic">
                  <img src={BaccaratClassic} />
                </a>
              </li>
              <li>
                <a href="/casino/awc-extra-sicbo">
                  <img src={SicBo} />
                </a>
              </li>
              <li>
                <a href="/casino/awc-red-blue-duel">
                  <img src={RedBlueDuel} />
                </a>
              </li>
              <li>
                <a href="/casino/awc-extra-andar-bahar">
                  <img src={ExtraAndarBahar} />
                </a>
              </li>
              <li>
                <a href="/casino/awc-thai-fish-prawn-crab">
                  <img src={awcthaifishprawncrab} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default AeSexy;
